module.exports = __webpack_public_path__ + "img/zhangli.4d55d63e.png";